<template>
  <div class="company-notification-settings-page">
    <CompanyWideProjectNotificationSettings/>
  </div>
</template>

<script>
import CompanyWideProjectNotificationSettings from '@/setting/CompanyWideProjectNotificationSettings.vue'

export default {
  name: 'ProjectNotificationCompanySettings',
  components: { CompanyWideProjectNotificationSettings }
}
</script>
